import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMarkdown/StreamChar.tsx
import * as React from "react";
import { ChatMarkdownContext } from "./context.mjs";
import { STREAM_REVEAL_HOLD_MS, STREAM_REVEAL_MS, streamRevealProps, useStreamingAge } from "./streamingAnimation.mjs";
import { Fragment, jsx } from "react/jsx-runtime";
var CharSpan = React.memo(({ char, globalIndex }) => {
  const { animateState, settledAt = Number.NEGATIVE_INFINITY } = React.use(ChatMarkdownContext);
  const { age, start } = useStreamingAge(animateState, globalIndex);
  const reveal = streamRevealProps(age);
  if (!reveal.className || start + STREAM_REVEAL_MS + STREAM_REVEAL_HOLD_MS <= settledAt) return /* @__PURE__ */ jsx(Fragment, { children: char });
  return /* @__PURE__ */ jsx("span", { ...reveal, children: char });
});
CharSpan.displayName = "CharSpan";
var StreamChar = React.memo(({ charIndex, children }) => /* @__PURE__ */ jsx(CharSpan, { globalIndex: Number(charIndex), char: children }));
StreamChar.displayName = "StreamChar";
export {
  StreamChar
};
//# sourceMappingURL=StreamChar.mjs.map